export default {
	name: 'Convention.Checkout.Availability',
	path: 'convention/checkout/availability',
	topLevel: true,
	meta: {
		auth: true,
		submenu: false
	},
	form: false
}